import { VerdictConfig, VerdictOverrideConfig, VerdictOverrideConfigFiltersToFind } from '@yandex-int/k-common';

type FilterKeys = keyof VerdictOverrideConfig['filters'];
type FilterValues = VerdictOverrideConfig['filters'][FilterKeys];
type MultipleFilterKeys = keyof {
    [key in FilterKeys as NonNullable<VerdictOverrideConfig['filters'][key]> extends any[] ? key : never]: never;
};

export const getFirstVerdictConfigOverrideByFilters = (
    verdictConfig: VerdictConfig | null,
    filter?: VerdictOverrideConfigFiltersToFind
) => {
    if (!verdictConfig || !filter || !Object.entries(filter).length) {
        return undefined;
    }

    return verdictConfig?.override.find((rule) => {
        return Object.entries(rule.filters).every((filterToApply) => {
            const [filterKey, filterValue] = filterToApply as [FilterKeys, FilterValues];

            if (Array.isArray(filterValue)) {
                const value = filter[filterKey as MultipleFilterKeys];

                if (!value) {
                    return false;
                }

                return filterValue.includes(value);
            }

            return filter[filterKey] === filterValue;
        });
    });
};
